export { SectionContentWrapper, DS_SECTION_BACKGROUND_CAP, sectionBandCapClass } from './section-content-wrapper'
export type { SectionContentWrapperProps } from './section-content-wrapper.types'
